import React from 'react';

const ChatStatusMessage = ({ content, active }) => (
  <div className="flex items-center justify-center p-2 my-2 text-xs rounded bg-blue-50">
    <span className={active ? "font-medium text-blue-700 animate-pulse transition-colors" : "font-medium text-blue-700"}>
      {content}
    </span>
  </div>
);

export default ChatStatusMessage; 